import React, { Component } from "react";
import "./NotFound.css";
import CheckAppVersion from "../components/CheckAppVersion";
import { Container, Row, Col } from "react-bootstrap";

export default class NotFound extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }
  componentDidMount = () => {
  }
  render() {
    return (
      <div className="NoFound">
        <CheckAppVersion getVersion={this.props.getVersion}/>
        <Container className="mt-5">
          <Row className="pt-5">
            <Col className="text-center mt-5">
              <h3>Sorry, page not found!</h3>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}